import { transformEnumToDisplay } from '@fruitful/member-profile';
import type { ColumnEditorOptions } from 'primereact/column';
import type { MultiSelectChangeEvent } from 'primereact/multiselect';

import {
    MultiSelectEditor,
    type MultiSelectOption,
} from '../../../common/components/GridCellEditors';
import { InsuranceCoverage } from '../../../entities/entityTypes';

export const InsuranceCoverageEditor = (options: ColumnEditorOptions) => {
    const insuranceCoverages = Object.values(InsuranceCoverage).map(
        (insuranceCoverage) => ({
            label: transformEnumToDisplay(insuranceCoverage),
            value: insuranceCoverage,
        }),
    );

    return (
        <MultiSelectEditor
            options={options}
            multiSelectProps={{
                options: insuranceCoverages,
                placeholder: 'Select Insurance Coverage',
                onChange: (e: MultiSelectChangeEvent) => {
                    // Handle "None" case

                    // If None is selected, clear all other values.
                    if (
                        (e.selectedOption as MultiSelectOption).value ===
                            (InsuranceCoverage.NONE as string) &&
                        (e.value as string[]).includes(InsuranceCoverage.NONE)
                    ) {
                        e.value = [InsuranceCoverage.NONE];
                    }

                    // If a non-None option is selected, unselect None.
                    if (
                        (e.selectedOption as MultiSelectOption).value !==
                            (InsuranceCoverage.NONE as string) &&
                        (e.value as string[]).includes(InsuranceCoverage.NONE)
                    ) {
                        e.value = (e.value as string[]).filter(
                            (option) =>
                                option !== (InsuranceCoverage.NONE as string),
                        );
                    }

                    options.editorCallback?.(e.value ?? null);
                },
            }}
        />
    );
};
